export default "__VITE_ASSET__AaRyvY7r__"